// Importado como PRIMEIRA linha do main.tsx, de propósito: roda antes de qualquer
// store/estado ler o localStorage, para que a limpeza por mudança de versão de
// storage aconteça antes da inicialização.
import { resetStorageIfOutdated } from "./appRefresh";

resetStorageIfOutdated();
